import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import styles from "./style.module.css";
import headerImg from "./assets/taxPlanningSectionImg.png";
import { getItemLocal, getUserId, removeSlash, setItemLocal } from "../../../../common_utilities";
import { ASSESSMENT_YEAR, TAX_GET_USER_PAYMENT_STATUS_API_URL } from "../../../../constants";
import { trackWebEngageEvent } from "../../../../Utils/Webengageevent/webengageUtils";

function ITRFileHeaderSection() {
  const [currentLocation, setCurrentLocation] = useState("");
  const [isVisible, setIsVisible] = useState(true);
  const [height, setHeight] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [checkPaymentStatus, setCheckPaymentStatus] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const listenToScroll = () => {
    const showFrom = 350;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    setHeight(winScroll);
    setIsVisible(winScroll >= showFrom);
  };

  // const member = getItemLocal("pd") ?? "";
  // const docUserId = member.user_id ?? "";

  const paymentStatus = async () => {
    try {
      const res = await axios.post(TAX_GET_USER_PAYMENT_STATUS_API_URL, {
        user_id: getUserId(),
        check_payment: "1",
        assessment_year: ASSESSMENT_YEAR,
      });

      const result = res.data;

      if (result["error_code"] === "100") {
        setIsLoading(false);
        setCheckPaymentStatus(true);
        setItemLocal("pid", result.data[0].payment_plan);

        // navigate(`${process.env.PUBLIC_URL}/itr-upload-docs`);
        // dispatch({
        //   type: "RENDER_TOAST",
        //   payload: { message: result["message"], type: "success" },
        // });
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error in paymentStatus:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  }, []);

  useEffect(() => {
    setIsVisible(false);
    setCurrentLocation(location.pathname);
    // if (docUserId) {
    paymentStatus();
    // }
  }, []);

  const handleFilingClick = () => {
    if (isLoading) return;

    trackWebEngageEvent("start filing clicked", {
      cta_name: "ITR filing started" ?? '',
      Service : "ITR",
      url : window.location.href
    });

    if (checkPaymentStatus) {
      navigate(`${process.env.PUBLIC_URL}/itr-profile`);
    } else {
      document.getElementById("ITRVideoSection")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleMobileFilingClick = () => {
    if (isLoading) return;

    trackWebEngageEvent("start filing clicked", {
      cta_name: "ITR filing started" ?? '',
      Service : "ITR",
      url : window.location.href
    });

    if (checkPaymentStatus) {
      navigate(`${process.env.PUBLIC_URL}/itr-profile`);
    } else {
      document.getElementById("ITRVideo")?.scrollIntoView({ behavior: "smooth" });
    }
  };


  return (
    <>
      <section className={`${styles["header-section"]} `}>
        <div className={` ${styles["header-section-container"]}`}>
          <div
            className={`${styles["header-section-background-overlay"]}`}
          ></div>
          {["/web/income-tax-filing-ae", "/web/income-tax-filing", "/web/itr_2024"].indexOf(
            removeSlash(currentLocation)
          ) > -1 ? (
            <>
              <div
                className={`text-center w-100 d-flex justify-content-center position-absolute ${styles.HeaderTop}`}
              >
                <img
                  className={`${styles.LogoHeader}`}
                  src={process.env.REACT_APP_STATIC_URL + "media/wp/Fintoologo_.svg"}
                  alt="Fintoo logo"
                />
              </div>
            </>
          ) : (
            <></>
          )}

          <div
            className={
              ["/web/income-tax-filing-ae", "/web/income-tax-filing", "/web/itr_2024"].indexOf(
                removeSlash(currentLocation)
              ) > -1
                ? styles.HeaderContent
                : styles.HeaderContent1
            }
          >
            <h2 className={styles.HeaderTitleSection}>
              File Your{" "}
              <span style={{ color: "#042b62", fontWeight: "700" }}>
                ITR
              </span>
            </h2>
            <h3 className={styles.HeadersubTitleSection}>Anywhere, Anytime</h3>
            <h3 className={styles.HeadersubTitleSection}>
              <span className={styles.HeadersubtextTitleSection} style={{ color: "#042b62" }}>
                45 Minutes Only!
              </span>
            </h3>


            <div className={styles.ITRFilingBtn}>
              <button onClick={handleFilingClick} disabled={isLoading}>
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Loading...
                  </>
                ) : (
                  checkPaymentStatus ? "Continue Filing" : "Start Filing"
                )}
              </button>
            </div>




            <div className="d-flex justify-content-center mt-md-4">
              <a style={{ scrollBehavior: "smooth" }} href="#ITRVideoSection">
                <div className={styles.mouseicon}>
                  <span></span>
                </div>
              </a>
            </div>
            {isVisible && (
              <div className={`d-md-none d-block ${styles.ITRFilingBtnMobile}`}>
                <button onClick={handleMobileFilingClick} disabled={isLoading}>
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Loading...
                    </>
                  ) : (
                    checkPaymentStatus ? "Continue Filing" : "Start Filing"
                  )}
                </button>
              </div>
            )}

          </div>
        </div>
      </section>
    </>
  );
}

export default ITRFileHeaderSection;
